import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { DASHBOARD_URL } from '../constants/URLS.const';
import { RootState } from '../store/store';
export function PublicRoute() {
    const isAuthenticated = useSelector(
        (state: RootState) => state.user.user?.accessToken
    );

    return !isAuthenticated ? <Outlet /> : <Navigate to={DASHBOARD_URL} />;
}
